import moment from 'moment'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { lastUtils } from '@last/core'

import { useAuthStore } from '@/store/auth'

export type OnboardingStep =
  | 'missing-info'
  | 'location-info'
  | 'demo-scheduling'
  | 'call-scheduling'
  | 'catalog-importer'
  | 'legal-info'
  | 'summary'
  | 'menu'

const steps = ref<OnboardingStep[]>(['missing-info', 'menu', 'demo-scheduling', 'summary'])

const isTest = ref(true)

export function useOnboarding() {
  function parseDemoDate(service: string) {
    const { locale } = useI18n()
    const booking = getBooking.value[service]
    const date = moment(booking.bookingDate).locale(locale.value)
    const dayText = date.format('dddd')
    const day = {
      day: dayText.charAt(0).toUpperCase() + dayText.slice(1),
      numberDay: date.format('DD'),
      month: date.format('MMMM'),
      year: date.format('YYYY')
    }
    const time = moment(booking.bookingDate).format('HH:mm')
    return { day, time }
  }

  const getBooking = computed(() => {
    const { onboarding } = useAuthStore()
    if (!onboarding?.bookings) return {}
    return lastUtils.index(onboarding.bookings, 'bookingType')
  })

  const isMobile = ref(computed(() => window.innerWidth < 640))
  const isDesktop = ref(computed(() => !isMobile.value))

  function setTestUser(value: boolean) {
    isTest.value = value
  }

  function getAnalyticsData() {
    const result: Record<string, string> = {
      Form: 'v2'
    }
    const fields = [
      'form',
      'gclid',
      'marketing_id',
      'referrername',
      'utm_adgroup',
      'utm_adname',
      'utm_campaign',
      'utm_content',
      'utm_medium',
      'utm_source',
      'utm_term'
    ]
    return fields.reduce((res, cookie) => {
      try {
        let value = getCookie(cookie)
        if (value) res[cookie] = value
        if (cookie === 'utm_source' && !value && !!document.referrer) {
          const referrer = document.referrer
          const url = new URL(referrer)
          value = url.hostname.replace('www.', '')
          res[cookie] = value
          res['utm_medium'] = 'organic'
        }
        return res
      } catch {
        return res
      }
    }, result)
  }

  function getCookie(name: string) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop()?.split(';').shift()
  }

  function addStep(step: OnboardingStep, index: number) {
    steps.value[index] = step
  }

  const allSteps = computed(() => [
    'missing-info',
    'menu',
    'demo-scheduling',
    'call-scheduling',
    'summary',
    'whatsapp'
  ])

  const demoCustomized = computed(() => {
    const { onboarding } = useAuthStore()
    const { storeUrl, bussinesName, businessType, taxId, businessAddress } = onboarding
    return storeUrl || bussinesName || businessType || taxId || businessAddress
  })

  return {
    isMobile,
    isDesktop,
    steps,
    getAnalyticsData,
    parseDemoDate,
    getBooking,
    isTest,
    allSteps,
    addStep,
    demoCustomized,
    setTestUser
  }
}
